const installHumbleMobileMenuFix = () => {
  const NavigationWrapper = customElements.get("navigation-wrapper");
  if (!NavigationWrapper) return;

  const proto = NavigationWrapper.prototype;
  if (proto.__humbleSmoothMobileBackPatched) return;

  const originalDrawerCloseSecondary = proto.drawerCloseSecondary;

  proto.drawerCloseSecondary = function (target) {
    if (!this.isDrawer) {
      return originalDrawerCloseSecondary.call(this, target);
    }

    const {
      active,
      openDrawerPanel,
      closeDrawerPanel,
      closing,
      open,
      opening,
    } = this.classes;

    target.classList.remove(openDrawerPanel, opening);
    target.classList.add(closeDrawerPanel, closing);

    const container = target.querySelector(":scope > .submenu__container");
    const inner = container?.querySelector(":scope > .submenu__inner");
    const relevantTargets = new Set([target, container, inner].filter(Boolean));

    const allAnimations = target.getAnimations({ subtree: true });
    const panelAnimations = [];

    allAnimations.forEach((animation) => {
      const animationTarget = animation.effect?.target;

      if (relevantTargets.has(animationTarget)) {
        panelAnimations.push(animation);
        return;
      }

      // Eclipse normally waits for every child animation before finishing the
      // back action. Complete those immediately so images/promos cannot stall it.
      try {
        animation.finish();
      } catch (_error) {
        // Ignore animations that cannot be force-finished.
      }
    });

    let cleanedUp = false;
    const cleanup = () => {
      if (cleanedUp) return;
      cleanedUp = true;

      target.classList.remove(
        closeDrawerPanel,
        closing,
        open,
        active,
        opening,
        openDrawerPanel,
      );

      document.querySelectorAll(this.selectors.toggles).forEach((input) => {
        input.checked = false;
      });
    };

    if (panelAnimations.length === 0) {
      requestAnimationFrame(cleanup);
      return;
    }

    Promise.allSettled(panelAnimations.map((animation) => animation.finished))
      .then(cleanup);
  };

  Object.defineProperty(proto, "__humbleSmoothMobileBackPatched", {
    value: true,
    configurable: false,
    enumerable: false,
    writable: false,
  });
};

if (customElements.get("navigation-wrapper")) {
  installHumbleMobileMenuFix();
} else {
  customElements.whenDefined("navigation-wrapper").then(installHumbleMobileMenuFix);
}
